<!-- items-dublicate.component.html -->
<div class="duplicate-leads-container">
  <!-- Handle array case -->
  <ng-container *ngIf="isArray(duplicatedLeads)">
    <div *ngFor="let lead of duplicatedLeads" class="lead-card" [class.primary-selected]="lead.isPrimary">
      <!-- Header Section -->
      <div class="lead-header">
        <div class="lead-info">
          <h3 class="lead-name">
            <a [href]="'leads/leads-managment/manage/' + lead?.id" target="_blank" class="lead-name-link">
              {{ lead?.fullName || 'No Name' }}
            </a>
            <span class="status-badge" [ngClass]="'status-' + (lead?.status | lowercase)">
              {{ lead?.status || 'Unknown' }}
            </span>
          </h3>
          <div class="contact-info">
            <span class="email">
              <i class="icon">✉️</i>
              {{ lead?.email || 'No Email' }}
            </span>
            <div class="contact-row">
              <span class="phone">
                <i class="icon">📱</i>
                {{ lead?.phoneNumber || 'No Phone' }}
              </span>
              <span class="created-date">
                <i class="icon">📅</i>
                {{ formatDate(lead?.created_at) || 'No Date' }}
              </span>
            </div>
          </div>
        </div>
        <div class="primary-selector">
          <mat-checkbox
            [(ngModel)]="lead.isPrimary"
            (change)="selectPrimary(lead)"
            color="primary"
          >
            <span class="checkbox-label">Primary</span>
          </mat-checkbox>
        </div>
      </div>

      <!-- Details Section -->
      <div class="lead-details">
        <div class="detail-group">
          <div class="detail-badge">
            <span class="badge-label">Campus</span>
            <span class="badge-value">{{ lead?.campus?.name || 'None' }}</span>
          </div>
          <div class="detail-badge">
            <span class="badge-label">Program</span>
            <span class="badge-value">{{ lead?.program?.name || 'None' }}</span>
          </div>
          <div class="detail-badge">
            <span class="badge-label">Cohort</span>
            <span class="badge-value">{{ lead?.cohort?.title || 'None' }}</span>
          </div>
          <div class="detail-badge">
            <span class="badge-label">Step</span>
            <span class="badge-value">{{ lead?.step?.name || 'None' }}</span>
          </div>
        </div>
      </div>

      <!-- Stats Section -->
      <div class="lead-stats">
        <div class="stat-item">
          <span class="stat-number">{{ lead?._count?.note || 0 }}</span>
          <span class="stat-label">Notes</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ lead?._count?.tasks || 0 }}</span>
          <span class="stat-label">Activities</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ lead?._count?.messages || 0 }}</span>
          <span class="stat-label">Messages</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ lead?._count?.lead_documents || 0 }}</span>
          <span class="stat-label">Documents</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ lead?._count?.lead_applications || 0 }}</span>
          <span class="stat-label">Applications</span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Handle single object case (preview mode) -->
  <ng-container *ngIf="!isArray(duplicatedLeads)">
    <div class="lead-card preview-mode">
      <!-- Header Section -->
      <div class="lead-header">
        <div class="lead-info">
<!-- AFTER -->
<h3 class="lead-name">
  <a [href]="'leads/leads-managment/manage/' + duplicatedLeads?.id" target="_blank" class="lead-name-link">
    {{ duplicatedLeads?.fullName || 'No Name' }}
  </a>
  <span class="status-badge" [ngClass]="'status-' + (duplicatedLeads?.status | lowercase)">
    {{ duplicatedLeads?.status || 'Unknown' }}
  </span>
</h3>
          <div class="contact-info">
            <span class="email">
              <i class="icon">✉️</i>
              {{ duplicatedLeads?.email || 'No Email' }}
            </span>
            <div class="contact-row">
              <span class="phone">
                <i class="icon">📱</i>
                {{ duplicatedLeads?.phoneNumber || 'No Phone' }}
              </span>
              <span class="created-date">
                <i class="icon">📅</i>
                {{ formatDate(duplicatedLeads?.created_at) || 'No Date' }}
              </span>
            </div>
          </div>
        </div>
        <div class="preview-badge">
          <span>Preview</span>
        </div>
      </div>

      <!-- Details Section -->
      <div class="lead-details">
        <div class="detail-group">
          <div class="detail-badge">
            <span class="badge-label">Campus</span>
            <span class="badge-value">{{ duplicatedLeads?.campus?.name || 'None' }}</span>
          </div>
          <div class="detail-badge">
            <span class="badge-label">Program</span>
            <span class="badge-value">{{ duplicatedLeads?.program?.name || 'None' }}</span>
          </div>
          <div class="detail-badge">
            <span class="badge-label">Cohort</span>
            <span class="badge-value">{{ duplicatedLeads?.cohort?.title || 'None' }}</span>
          </div>
          <div class="detail-badge">
            <span class="badge-label">Step</span>
            <span class="badge-value">{{ duplicatedLeads?.step?.name || 'None' }}</span>
          </div>
        </div>
      </div>

      <!-- Stats Section -->
      <div class="lead-stats preview-stats">
        <div class="stat-item">
          <span class="stat-number">{{ duplicatedLeads?._count?.note || 0 }}</span>
          <span class="stat-label">Notes</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ duplicatedLeads?._count?.tasks || 0 }}</span>
          <span class="stat-label">Activities</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ duplicatedLeads?._count?.messages || 0 }}</span>
          <span class="stat-label">Messages</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ duplicatedLeads?._count?.lead_documents || 0 }}</span>
          <span class="stat-label">Documents</span>
        </div>
        <div class="stat-item">
          <span class="stat-number">{{ duplicatedLeads?._count?.lead_applications || 0 }}</span>
          <span class="stat-label">Applications</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>